export const config = {
  headerHeight: 30,
  fontSize: 12,
  fontWeight: 600,
  headerText: `Explore and filter the Vector Strength Histogram to identify certain Vector Sets to study more closely.`,
  borderBottom: "1px solid grey",
};
